import React, { useState, useEffect, } from 'react';
import { useHistory } from "react-router-dom";
import { ModalOptionForm } from '../molecules/modalOptionForm';
import useMedia from "use-media";
import { PullDownOptionForm } from '../molecules/pullDownOptionForm';
import { connect } from 'react-redux';
import { Button } from '../atoms/button';
import { GetPublicHoliday } from "../../hooks/getPublicHoliday";
import { golfFacility, vacancyOverviewApi } from "../../const";
import common from "../../resources/js/common/common";
import "../../resources/css/search/search.css";

const VacancyInfoContainer = (props) => {
    const {
        playDate1, 
        group, 
        startTime,
        course,
        setCourse,
        setGroup, 
        kaiinken,
        setKaiinken,
        setPlayDate1,
        setSearchResult, 
        onClickPlay, 
        onClickOpenStartTimeWindow,
        onClickOpenSelectAreaWindow,
        setReserveCheckInfo,
        displaySwitch,
        runGetVacancyList,
        getWeekList,
        getYearMonth } = props;

    const { getHoliday } = GetPublicHoliday();

    const isMobilePhone = useMedia({ maxWidth: '480px' });
    const [mobilePhone, setMobilePhone] = useState(false);
    const [vacancyOverview, setVacancyOverview] = useState([]);
    const [vacancyList, setVacancyList] = useState([]);
    const [weekList, setWeekList] = useState([]);
    const [nextFlag, setNextFlag] = useState(false);
    const [groupNumber, setGroupNumber] = useState("1");
    const [NotSearch,setNotSearch]= useState(false);

    const [errorFlg, setErrorFlg] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [MonthHead, setMonthHead] = useState();
    const [MonthLast, setMonthLast] = useState();

    const [kaiinkenNumber, setKaiinkenNumber] = useState("1");

    const history = useHistory();
    let twoWeeks = [];

    useEffect(() => {
        if (isMobilePhone) {
            setMobilePhone(true);
        } else {
            setMobilePhone(false);
        }
    }, [isMobilePhone]);



    // 初回表示時
    useEffect(() => {
        // 検索基準の日付を設定
        // const playDate = new Date(playDate1);

        // let y = playDate.getFullYear();
        // let m = playDate.getMonth() + 1;
        // let d = playDate.getDate();

        // if (m < 10) m = `0${m}`
        // if (d < 10) d = `0${d}`


        // let groupNumber = 1;
        // group.forEach((data) => {
        //     if (data.selected === true) groupNumber = parseInt(data.id); 
        // });

        // const startTimeArray = [];
        // startTime.forEach((data) => {
        //     if (data.checked === true) startTimeArray.push(data.id);
        // });
        // const startTimeStr =  startTimeArray.join();

        // const courseArray = [];
        // course.forEach((data) => {
        //     if (data.checked === true) courseArray.push(data.id);
        // });
        
        // //選択された会員権から施設コードを詰め込む
        // let courseArrayKaiinken;
        // let useMemberShipAuth;
        // let kaiinKind;
        // kaiinken.forEach((data) => {
        //     if (data.selected === true) {
        //         courseArrayKaiinken = data.sisetuCd;
        //         kaiinKind = data.kaiinkenSyubetCd;
        //         course.forEach((courseData) => {
        //             if(courseData.id === data.facilityCd){
        //                 useMemberShipAuth = courseData.memberShipAuth
        //             }
        //         })
        //     }
        // });
        
        // const req = {
        //     startDate: `${y}-${m}-${d}`, 
        //     teeTime: startTimeStr, 
        //     partyCount: groupNumber,
        //     membershipAuthID:useMemberShipAuth,
        //     userFacility: courseArrayKaiinken,
        //     kaiinKind:kaiinKind,
        //     courseId: courseArray,
        //     syoriKbn:"0"
        // }
        // runGetVacancyList(req);

    }, [course]);


    // 検索ボタン押下時
    const onClickSearch = () => {
        setReserveCheckInfo([]);
        const playDate = new Date(playDate1);
        // 検索基準の日付を設定
        const nextDate = new Date(playDate.getFullYear(), playDate.getMonth(), playDate.getDate());

        let y = nextDate.getFullYear();
        let m = nextDate.getMonth() + 1;
        let d = nextDate.getDate();

        if (m < 10) m = `0${m}`
        if (d < 10) d = `0${d}`


        let groupNumber = 1;
        group.forEach((data) => {
            if (data.selected === true) groupNumber = parseInt(data.id); 
        });

        const startTimeArray = [];
        startTime.forEach((data) => {
            if (data.checked === true) startTimeArray.push(data.id);
        });
        const startTimeStr =  startTimeArray.join();

        const courseArray = [];
        course.forEach((data) => {
            if (data.checked === true) courseArray.push(data.id);
        });

        //選択された会員権から施設コードを詰め込む
        let courseArrayKaiinken;
        let useMemberShipAuth;
        let kaiinKind;
        kaiinken.forEach((data) => {
            if (data.selected === true) {
                courseArrayKaiinken = data.sisetuCd;
                kaiinKind = data.kaiinkenSyubetCd;
                course.forEach((courseData) => {
                    if(courseData.id === data.facilityCd){
                        useMemberShipAuth = courseData.memberShipAuth
                    }
                })
            }
        });

        const req = {
            startDate: `${y}-${m}-${d}`, 
            courseId: courseArrayKaiinken,
            teeTime: startTimeStr, 
            partyCount: groupNumber,
            membershipAuthID:useMemberShipAuth,
            userFacility: courseArrayKaiinken,
            kaiinKind:kaiinKind,
            courseId: courseArray,
            syoriKbn:"0"
        }
        runGetVacancyList(req);
    }


    // プレー日表示処理
    const getDateToString = () => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const playDate = new Date(playDate1);
        const m = playDate.getMonth() + 1;
        const d = playDate.getDate();

        return `${m}月${d}日(${youbi[playDate.getDay()]})`;
    }

    const getStartTimeToString = () => {
        let textValue = "";
        let onCheckFlg = false;
        for (var i in startTime) {
            if (startTime[i].checked === true) {
                textValue = textValue + (textValue == "" ? "" : ", ");
                textValue = textValue + startTime[i].value;
                onCheckFlg = true;
            }
        }
        return (onCheckFlg ? textValue : "選択なし");
    }
    

    
    // 選択した組数をstoreに保存
    const onChangeGroup = (e) => {
        setGroupNumber(e.target.value);

        group.forEach((data) => {
            if (data.id === e.target.value) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setGroup(group);
    };

    const onChangeKaiinkenName = (e) => {
        setKaiinkenNumber(e.target.value);
        kaiinken.forEach((data) => {
            if (String(data.id) === e.target.value) {
                data.selected = true;
                console.log("施設取得のリクエストデータ(会員権の選択が変更された)");
                console.log(data);
                common.doPost(golfFacility, {kaiinKind:data.kaiinkenSyubetCd,sisetuCd:data.sisetuCd}, afterGetFacility);
            } else {
                data.selected = false;
            }
        })
        setKaiinken(kaiinken);
    }

    // 施設取得後処理
    const afterGetFacility = (res) => {
        const data = res.data.map((item) => {
            return {
                id: item.courseid,
                facilityCd: item.facility_cd,
                value: item.facility_name,
                category: item.hotel_category_name,
                class: "area_course",
                checked: true,
                zip: item.zip,
                address: item.address,
                access_car: item.access_car,
                facility_overview_title: item.facility_overview_title,
                facility_overview_detail: item.facility_overview_detail,
                url: item.url,
                image_path: item.image_path,
                memberShipAuth: item.memberShipAuth,
                sortNum:parseInt(item.inside_category_sort),
            };
        });
        //表示施設のソート処理
        data.sort(function(first,second){
            if (first.sortNum > second.sortNum){
                return 1;
            }else if (first.sortNum < second.sortNum){
                return -1;
            }else{
                return 0;
            }
        })

        setCourse(data);
    }

    const getCourseName = () => {
        const array = course.filter((data) => {
            return data.checked === true;
        });

        if (array.length === 0) {
            return "選択なし";
        }

        if (array.length === course.length) {
            return "すべて";
        } else {
            const text = array.map((data) => {
                return data.value;
            });
            return text.join(", ");
        }
    }

    

    return (
        <div style={style.container}>
            <div style={style.vacancy__title}>
                {isMobilePhone ? (<>
                    <h5>カレンダーから探す</h5>
                </>) : (<>
                    <h3>カレンダーから探す</h3>
                </>)}
            </div>
            <div style={style.searchConditions}>
                <div style={NotSearch ? {display: "block" ,color:"red" ,textAlign:"center",fontSize:"0.8rem",background: "rgba(255,255,255,0)",border: 0,fontWeight:"bold"}:{display: "none"}} > 検索に失敗しました</div>
                <div style={style.search}>
                    <ModalOptionForm
                        id={"playDate1"}
                        divClass={mobilePhone ? "wrapMobile" : "wrap"}
                        title={"プレー日"}
                        onClick={onClickPlay}
                        text={getDateToString()}
                    />
                    <ModalOptionForm 
                        divClass={mobilePhone ? "wrapMobile" : "wrap"}
                        title={"スタート時間"} 
                        onClick={onClickOpenStartTimeWindow} 
                        text={getStartTimeToString()}/>
                    <PullDownOptionForm
                        divClass={mobilePhone ? "wrapMobile" : "wrap"}
                        title={"会員権選択"}
                        selectClass={"pullDownOptionStyle"}
                        data={kaiinken}
                        state={kaiinkenNumber}
                        onChange={onChangeKaiinkenName} 
                    />
                    <PullDownOptionForm
                        divClass={mobilePhone ? "wrapMobile" : "wrap"}
                        title={"組数"}
                        selectClass={"pullDownOptionStyle"}
                        data={group}
                        state={groupNumber}
                        onChange={onChangeGroup}
                    />
                    <ModalOptionForm
                        divClass={mobilePhone ? "wrapMobile" : "wrap"}
                        title={"ゴルフ場"}
                        onClick={onClickOpenSelectAreaWindow}
                        text={getCourseName()} />

                    
                </div>
                <div style={style.searchbox}>
                    <Button buttonText="検 索" className={mobilePhone ? "searchBtnStyleSp" : "searchBtnStylePc"} onClick={onClickSearch} />
                </div>
            </div>
        </div>
    );
}


const style = {
    container: {
        // width: "75%",
        marginRight: "auto",
        marginLeft: "auto",
        // backgroundColor: "white",
    },
    vacancy__title: {
        fontWeight: "bold",
        textAlign: "center",
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
    },
    link: {
        textDecoration: "none",
        color: "#3d7ab3",
        fontWeight: "bold",
        fontSize: "11px",
        float: "right",
    },
    line: {
        clear: "both",
    },
    searchConditions: {
        width: "100%",
    },
    searchbox: {
        width: "100%",
        paddingBottom: "10px",
        margin:"10px auto"
    },
    labelStyle: {
        width: "9rem",
        lineHeight: "1.2rem",
        verticalAlign: "middle",
        letterSpacing: "0.2rem",
        display: "block",
    },
    labelStyle2: {
        lineHeight: "1.2rem",
        display: "inline-block",
        marginLeft: 7
    },
    selectStyle: {
        display: "inline-block",
        width: "5rem",
        height: "2rem",
        border: "solid 1px #b7b7b7",
        padding: "0 35px 0 10px",
        borderRadius: 2,
    },

    message: {
        color: "red",
        fontSize: "0.8rem",
        position: "relative",
        display: "inline-block",
    },
    messageLink: {
        textDecoration: "none",
        color: "#3d7ab3",
        fontWeight: "bold",
        fontSize: "0.8rem",
        position: "relative",
        display: "inline-block",
    },
    usageGuide: {
        fontSize: "0.7rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem",
    },
    table: {
        width: "100%",

    },
    table2: {
        width: "100%",

    },
    search: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
    },
    searchMobile: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        marginBottom: "20px",
    },
    monthStyle: {
        fontWeight: "bold",
        fontSize: "1.5rem",
        marginLeft: "5px",
    },
    monthStyleMobile: {
        fontWeight: "bold",
        fontSize: "1rem",
        marginLeft: "5px",
    },
}

const mapStateToProps = (state) => {
    return { 
        playDate1: state.playDate1,
        group: state.group,
        startTime: state.startTime,
        course: state.course,
        kaiinken:state.kaiinken,
     };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setGroup: (item) => {
            dispatch({ type: "GROUP", payload: { group: item } })
        },
        setPlayDate1: (item) => {
            dispatch({ type: "SELECT_PLAY_DATE1", payload: { playDate1: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: {kaiinken:item} })
        },
        setReserveCheckInfo: (item) => {
            dispatch({ type: "RESERVE_CHECK_INFO", payload: { reserveCheckInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VacancyInfoContainer);